/* Options:
Date: 2017-07-03 16:24:54
Version: 4.512
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: http://localhost:2201/auth/identityserver

//GlobalNamespace: 
//MakePropertiesOptional: True
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/


export interface IReturnVoid {
    createResponse(): void;
}

export interface IReturn<T> {
    createResponse(): T;
}

// @DataContract
export class ResponseError {
    // @DataMember(Order=1, EmitDefaultValue=false)
    errorCode: string;

    // @DataMember(Order=2, EmitDefaultValue=false)
    fieldName: string;

    // @DataMember(Order=3, EmitDefaultValue=false)
    message: string;

    // @DataMember(Order=4, EmitDefaultValue=false)
    meta: { [index: string]: string; };
}

// @DataContract
export class ResponseStatus {
    // @DataMember(Order=1)
    errorCode: string;

    // @DataMember(Order=2)
    message: string;

    // @DataMember(Order=3)
    stackTrace: string;

    // @DataMember(Order=4)
    errors: ResponseError[];

    // @DataMember(Order=5)
    meta: { [index: string]: string; };
}

export class Membership {
    id: number;
    userId: number;
    groupId: number;
}

export class UserTrialInstitution {
    id: number;
    userInstitutionId: number;
    trialId: number;
}

export class UserInstitution {
    id: number;
    userId: number;
    institutionId: number;
    userTrialInstitutions: UserTrialInstitution[];
}

export class User {
    id: number;
    firstName: string;
    lastName: string;
    subjectId: string;
    username: string;
    memberships: Membership[];
    userInstitutions: UserInstitution[];
}

export class UserDetails {
    id: number;
    firstName: string;
    lastName: string;
    subjectId: string;
    username: string;
}

export class HelloResponse {
    result: string;
}

export class GetUserResponse {
    responseStatus: ResponseStatus;
    user: User;
}

export class GetAllUsersResponse {
    responseStatus: ResponseStatus;
    users: User[];
}

export class GetUserDetailsResponse {
    responseStatus: ResponseStatus;
    userDetails: UserDetails;
}

// @DataContract
export class AuthenticateResponse {
    // @DataMember(Order=1)
    userId: string;

    // @DataMember(Order=2)
    sessionId: string;

    // @DataMember(Order=3)
    userName: string;

    // @DataMember(Order=4)
    displayName: string;

    // @DataMember(Order=5)
    referrerUrl: string;

    // @DataMember(Order=6)
    bearerToken: string;

    // @DataMember(Order=7)
    refreshToken: string;

    // @DataMember(Order=8)
    responseStatus: ResponseStatus;

    // @DataMember(Order=9)
    meta: { [index: string]: string; };
}

// @DataContract
export class AssignRolesResponse {
    // @DataMember(Order=1)
    allRoles: string[];

    // @DataMember(Order=2)
    allPermissions: string[];

    // @DataMember(Order=3)
    responseStatus: ResponseStatus;
}

// @DataContract
export class UnAssignRolesResponse {
    // @DataMember(Order=1)
    allRoles: string[];

    // @DataMember(Order=2)
    allPermissions: string[];

    // @DataMember(Order=3)
    responseStatus: ResponseStatus;
}

// @Route("/hello")
// @Route("/hello/{Name}")
export class Hello implements IReturn<HelloResponse>
{
    name: string;
    createResponse() { return new HelloResponse(); }
    getTypeName() { return "Hello"; }
}

// @Route("/user", "GET")
// @Route("/user/{Id}", "GET")
export class GetUser implements IReturn<GetUserResponse>
{
    id: number;
    createResponse() { return new GetUserResponse(); }
    getTypeName() { return "GetUser"; }
}

// @Route("/allusers", "GET")
export class GetAllUsers implements IReturn<GetAllUsersResponse>
{
    createResponse() { return new GetAllUsersResponse(); }
    getTypeName() { return "GetAllUsers"; }
}

export class GetUserDetails implements IReturn<GetUserDetailsResponse>
{
    id: number;
    createResponse() { return new GetUserDetailsResponse(); }
    getTypeName() { return "GetUserDetails"; }
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @Route("/authenticate")
// @Route("/authenticate/{provider}")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>
{
    // @DataMember(Order=1)
    provider: string;

    // @DataMember(Order=2)
    state: string;

    // @DataMember(Order=3)
    oauth_token: string;

    // @DataMember(Order=4)
    oauth_verifier: string;

    // @DataMember(Order=5)
    userName: string;

    // @DataMember(Order=6)
    password: string;

    // @DataMember(Order=7)
    rememberMe: boolean;

    // @DataMember(Order=8)
    continue: string;

    // @DataMember(Order=9)
    nonce: string;

    // @DataMember(Order=10)
    uri: string;

    // @DataMember(Order=11)
    response: string;

    // @DataMember(Order=12)
    qop: string;

    // @DataMember(Order=13)
    nc: string;

    // @DataMember(Order=14)
    cnonce: string;

    // @DataMember(Order=15)
    useTokenCookie: boolean;

    // @DataMember(Order=16)
    accessToken: string;

    // @DataMember(Order=17)
    accessTokenSecret: string;

    // @DataMember(Order=18)
    meta: { [index: string]: string; };
    createResponse() { return new AuthenticateResponse(); }
    getTypeName() { return "Authenticate"; }
}

// @Route("/assignroles")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>
{
    // @DataMember(Order=1)
    userName: string;

    // @DataMember(Order=2)
    permissions: string[];

    // @DataMember(Order=3)
    roles: string[];
    createResponse() { return new AssignRolesResponse(); }
    getTypeName() { return "AssignRoles"; }
}

// @Route("/unassignroles")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>
{
    // @DataMember(Order=1)
    userName: string;

    // @DataMember(Order=2)
    permissions: string[];

    // @DataMember(Order=3)
    roles: string[];
    createResponse() { return new UnAssignRolesResponse(); }
    getTypeName() { return "UnAssignRoles"; }
}



// WEBPACK FOOTER //
// ./src/dtos.ts